var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 17.2358V13.732C23.5 12.7922 23.4507 11.9857 23.3009 11.3119C23.1492 10.6295 22.8848 10.038 22.4235 9.57657C21.9621 9.11516 21.3705 8.85079 20.6881 8.69914C20.0143 8.54938 19.2078 8.5 18.268 8.5H13.732C12.7922 8.5 11.9857 8.54938 11.3119 8.69914C10.6295 8.85079 10.038 9.11516 9.57657 9.57657C9.11516 10.038 8.85079 10.6295 8.69914 11.3119C8.54938 11.9857 8.5 12.7922 8.5 13.732V18.268C8.5 19.2078 8.54938 20.0143 8.69914 20.6881C8.85079 21.3705 9.11516 21.962 9.57657 22.4234C10.038 22.8848 10.6295 23.1492 11.3119 23.3009C11.9857 23.4506 12.7922 23.5 13.732 23.5H18.268C19.2078 23.5 20.0143 23.4506 20.6881 23.3009C21.3705 23.1492 21.9621 22.8848 22.4235 22.4234C22.8848 21.962 23.1492 21.3705 23.3009 20.6881C23.4507 20.0143 23.5 19.2078 23.5 18.268V17.2706C23.5003 17.259 23.5003 17.2474 23.5 17.2358ZM10.1634 11.6373C10.0495 12.1498 10 12.8264 10 13.732V15.322C10.5399 14.8028 11.0425 14.3781 11.5292 14.0684C12.119 13.6931 12.7241 13.4618 13.3767 13.4618C14.0292 13.4618 14.6344 13.6931 15.2242 14.0684C15.8066 14.439 16.4117 14.9743 17.0763 15.6389L18.2952 16.8578C19.0327 16.2499 19.7559 15.8301 20.5342 15.7331C21.0469 15.6692 21.5304 15.7505 22 15.9398V13.732C22 12.8264 21.9505 12.1498 21.8366 11.6373C21.7246 11.1333 21.5605 10.835 21.3628 10.6372C21.165 10.4395 20.8667 10.2754 20.3627 10.1634C19.8502 10.0495 19.1736 10 18.268 10H13.732C12.8264 10 12.1498 10.0495 11.6373 10.1634C11.1333 10.2754 10.835 10.4395 10.6372 10.6372C10.4395 10.835 10.2754 11.1333 10.1634 11.6373Z",
    fill: "#D1D6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13C17.5 12.1716 18.1716 11.5 19 11.5C19.8284 11.5 20.5 12.1716 20.5 13C20.5 13.8284 19.8284 14.5 19 14.5C18.1716 14.5 17.5 13.8284 17.5 13Z",
    fill: "#D1D6DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhotoIcon);
export default __webpack_public_path__ + "static/media/no-photo-icon.0456e14fb2560ab5f82b2e0a0b715f5c.svg";
export { ForwardRef as ReactComponent };